/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

export { CreateAdminGroupContainer as CreateAdminGroup } from './CreateAdminGroup.container';
